export default __webpack_public_path__ + "static/media/image@3x.dc1cfb4d.jpg";